import React from 'react';
import Navbar from '../layouts/navbar';
import { Link } from 'react-router-dom';

const EducationAddiction = () => {
    return (
        <div>
            <Navbar head="Addiction" />
            <div className="container" style={{ marginTop: "50px" }}>
                <Link to="/faq">
                    <button id="myBtn" title="FAQ">
                        <i className="fas fa-info-circle faqicon"></i>
                        <p>  FAQ</p>
                    </button>
                </Link>


                <div className="row justify-content-center">
                    <div className="col-12 col-lg-8">
                        <div id="imgcarousel" className="carousel slide" data-ride="carousel">
                            <ol className="carousel-indicators">
                                <li data-target="#imgcarousel" data-slide-to="0" class="active"></li>
                                <li data-target="#imgcarousel" data-slide-to="1"></li>
                                <li data-target="#imgcarousel" data-slide-to="2"></li>
                            </ol>
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <img className="img-fluid" src="/assests/images/cannibus.jpg" alt="">
                                    </img>

                                </div>
                                <div className="carousel-item">
                                    <img className="img-fluid" src="/assests/images/cannibus.jpg" alt="">
                                    </img>

                                </div>
                                <div className="carousel-item">
                                    <img className="img-fluid" src="/assests/images/cannibus.jpg" alt="">
                                    </img>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <h2>Addiction 101</h2>
                    <p>Addiction is often regarded as a product of immorality and chalked up to simply being a bad choice that can be overturned easily with will. Such an understanding fails to take into account the fact that addiction is a disorder with biological and environmental components. As such, to take a moral stand against addicts is wrong, and dependents should be treated with dignity and respect as well.
                        </p>

                    <p>A complex condition, <b>addiction</b> is understood as <b>compulsive substance use despite harmful consequences.</b> Such repeated and copious drug use challenges self control which makes it <b>difficult to resist urges</b> to take drugs. Addiction, or Substance-Use Disorder (SUD) can cause <b>distorted thinking and behaviour</b> and have <b>drastic physical effects</b>. This can cause impairment in judgement, decision-making, learning and memory. </p>

                    <p>Continued drug use leads to the <b> development of tolerance </b> which implies that individual now requires larger amounts of the substance to feel the same effects. Stopping the intake of substance <b>may cause withdrawal</b> as the body (and the mind) develops dependency.
                    </p>

                    <p>
                        Why is it that some people get affected while others don’t? Several research studies indicate that factors such as genetic disposition <b>(addiction can be hereditary)</b>, environment <b> (peer pressure, family dynamics, early exposure to substance, stress</b>) and even <b>socio-economic background</b> can influence a person’s tendency to get addicted to a substance.
                    </p>

                    <p>
                        SUDs are a <b>“relapsing” disease</b>, which means that even after several years of sobriety, a recovering addict is at significant risk of falling into the same patterns again. However, this does not imply that treatment and recovery cannot take place since <b>addiction is manageable</b>. With a well-suited treatment plan and a supportive environment, the problem of addiction can be managed successfully.
    
                    </p>



                    <h4>Signs and Symptoms of Addiction</h4>
                    <p>An individual with an addiction will crave for the substance or depict certain behavioral patterns.</p>
                    <p><b>The general signs of addiction are:</b></p>
                    <ul>
                        <li><p>Lack in control or inability to resist any substance.</p></li>
                        <li><p>Abandonment in relationships or avoiding any sort of commitments.</p></li>
                        <li><p>Withdrawal symptoms like trembling, sweating or vomiting.</p></li>
                        <li><p>Abrupt loss in weight is also a physical symptom of addiction</p></li>
                        <li><p>Changes in personality like lying behavior in terms of amount of substance used, change in sleeping patterns which results to fatigue.</p></li>
                        <li><p>Signs that show a change in health are bloodshot eyes, poor state of skin, teeth, hair and nails.</p></li>
                        <li><p>Issues in memory and failure in recalling.</p></li>
                        <li><p>Slurred speech or rapid rambling.</p></li>
                    </ul>

                    <h4>Emotional Symptoms</h4>
                    <ul>
                        <li><p>Sudden changes in mood</p></li>
                        <li><p>Irritability</p></li>
                        <li><p>Aggressive bheaviour</p></li>
                        <li><p>Apathy</p></li>
                        <li><p>Suicidal thoughts</p></li>
                    </ul>
                    <p></p>
                    <h4>Effects of Drug Use</h4>
                    <p>Drug use can lead to several drastic physical, behavioural, and mental changes. While <b>each substance reacts with the body and mind in a different way</b>, there are certain effects that can be considered to be common occurrences across all drugs.</p>
                    <p>Physical effects include:</p>
                    <ul>

                        <li><p><b>Weakened immune system</b> which increases the risk of illnesses and infections</p></li>
                        <li><p><b>Heart conditions</b> such as heart attacks, abnormal heart rates, blood vessel infections.</p></li>
                        <li><p><b>Nausea and abdominal pains</b> that can cause changes in appetite and weight loss </p></li>
                        <li><p>Increased strain on liver which heightens <b>risk of liver damage</b> </p></li>
                        <li><p><b>Seizures, strokes, neural damage, brain damage</b> </p></li>
                        <li><p><b>Lung diseases</b> </p></li>
                        <li><p>Risk of developing viral infections like <b>HIV/AIDS, Hepatitis</b> </p></li>
                        <li><p>Other effects such as <b>problems in memory, attention, and decision-making</b> are also common. Repeated drug use can lead to severe <b>mental health problems</b>. Behavioural changes such as <b>paranoia, aggressiveness, hallucinations, impaired judgement, and loss of self control</b> may also develop.  </p></li>

                    </ul>

                </div>
            </div>
        </div>

    )
}
export default EducationAddiction;